import React, { useEffect, useRef, useState } from 'react';
import Page from '../../components/Page';
import { Field, FieldArray, Formik, Form as FormikForm } from 'formik';
import OrganizationHeader from './OrganizationHeader';
import { OrsRoutes } from '../../constants/routes';
import { useHistory, useLocation } from 'react-router-dom';
import { Box, Container, Grid, IconButton, Typography, makeStyles } from '@material-ui/core';
import { RenderTextField, StaticAlert, SubmissionType, RenderAutoCompleteFieldFixed } from '@mvrb-frontend/shared-ui';
import Button from '@material-ui/core/Button';
import { AddCircleOutline, Delete } from '@material-ui/icons';
import { useGetEngagementOrgs, useUploadExcelFile } from '../../hooks';
import { EngagementSchema } from '../../constants';
import { Error as ErrorIcon } from '@material-ui/icons';
import AdminLogoUpload from './AdminLogoUpload';

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.common.white,
    borderRadius: '0 0 4px 4px',
    boxShadow: '0 4px 16px 0 rgba(0,0,0,0.05)',
    padding: 0,
    paddingBottom: '32px',
    marginTop: '32px',
  },
  formSubHeader: {
    backgroundColor: theme.palette.secondary.light,
    padding: '10px 20px',
  },
  formContainer: {
    paddingLeft: '32px',
    paddingRight: '32px',
    paddingTop: '32px',
  },
  addButton: {
    padding: '0',
    minWidth: '85px !important',
    fontSize: '16px',
  },
  addItemBtn: {
    backgroundColor: '#F0F2F5',
  },
  alertContainer: {
    marginTop: '16px',
    marginRight: '32px',
    flex: 1,
  },
}));

const OrganizationEngagementPage = () => {
  const mapOptions = [
    {
      value: 'Acho Dene Koe',
      label: 'Acho Dene Koe',
      disabled: false,
    },
    {
      value: 'ADFN',
      label: 'ADFN',
      disabled: false,
    },
    {
      value: 'ADFN/NWTMN',
      label: 'ADFN/NWTMN',
      disabled: false,
    },
    {
      value: 'ADFN/NWTMN/Athabasca Denesuline',
      label: 'ADFN/NWTMN/Athabasca Denesuline',
      disabled: false,
    },
    {
      value: 'Dehcho First Nation (DFN)',
      label: 'Dehcho First Nation (DFN)',
      disabled: false,
    },
    {
      value: 'DFN/ADFN/NWT Métis Nation',
      label: 'DFN/ADFN/NWT Métis Nation',
      disabled: false,
    },
    {
      value: 'DFN/Akaitcho Dene First Nation (ADFN)',
      label: 'DFN/Akaitcho Dene First Nation (ADFN)',
      disabled: false,
    },
    {
      value: 'DFN/NWTMN',
      label: 'DFN/NWTMN',
      disabled: false,
    },
    {
      value: 'Ghotelnene Kodtineh Dene',
      label: 'Ghotelnene Kodtineh Dene',
      disabled: false,
    },
    {
      value: 'NWTMN',
      label: 'NWTMN',
      disabled: false,
    },
    {
      value: 'Sahtu Dene and Métis Settlement Area/ADFN',
      label: 'Sahtu Dene and Métis Settlement Area/ADFN',
      disabled: false,
    },
    {
      value: 'Tłc̨hǫ',
      label: 'Tłc̨hǫ',
      disabled: false,
    },
    {
      value: 'Tłıc̨hǫ/ADFN',
      label: 'Tłıc̨hǫ/ADFN',
      disabled: false,
    },
    {
      value: 'Tłc̨hǫ/ADFN/NWTMN',
      label: 'Tłc̨hǫ/ADFN/NWTMN',
      disabled: false,
    },
    {
      value: 'Tłıc̨hǫ/NWTMN',
      label: 'Tłıc̨hǫ/NWTMN',
      disabled: false,
    },
  ];

  const history = useHistory();
  const location1 = useLocation<any>();
  const classes = useStyles();

  const [items, setItems] = useState<any>([{ itemTitle: '' }]);
  const [origin, setOrigin] = useState<string>('Add');
  const [name, setName] = useState<string>('');
  const deletedItemsRef = useRef([]);
  const [imageName, setImageName] = useState<string>('');
  const [imageFile, setImageFile] = useState<any>(undefined);
  const [loadImage, setLoadImage] = useState<boolean>(false);

  const {
    submitEngagementOrgs,
    submitEngagementErrors,
    isSubmiting,
    getEngagementData,
    engagementData,
    successSubmit,
  } = useGetEngagementOrgs();

  const { isUploading, uploadComments, uploadFile, errors } = useUploadExcelFile();

  useEffect(() => {
    (async () => {
      if (location1.state?.source === 'edit') {
        const data = await getEngagementData(location1.state.id);
        setOrigin('Edit');
        setItems(data?.engagementItems);
      }
    })();
  }, []);

  useEffect(() => {
    if (successSubmit === true && isSubmiting === false && submitEngagementErrors.length == 0) {
      history.push({
        pathname: OrsRoutes.Engagement,
        state: {
          succes: true,
          engagementName: name,
          type: origin,
        },
      });
    }
  }, [successSubmit, isSubmiting]);

  useEffect(() => {
    if (engagementData?.image?.originalname) {
      setImageName(engagementData.image?.originalname);
      setLoadImage(true);
    }
  }, [engagementData]);

  const handleBack = () => {
    history.push(OrsRoutes.Engagement);
  };

  const handleSubmit = async values => {
    let responseImageData;
    const copyValues = { ...values };
    copyValues.location = copyValues.location.map(item => item.value).join(',');
    setName(values.name);

    //Edit
    if (origin === 'Edit') {
      if (imageFile) {
        //New loaded image
        responseImageData = (await uploadFile('/files', imageFile, true)) as any;
        submitEngagementOrgs(
          {
            ...copyValues,
            id: engagementData.id,
            imageId: responseImageData.data.id,
            deletedItems: deletedItemsRef.current,
          },
          SubmissionType.Update,
        );
      } else {
        submitEngagementOrgs(
          {
            ...copyValues,
            id: engagementData.id,
            imageId: values?.file === false ? null : values?.imageId,
            deletedItems: deletedItemsRef.current,
          },
          SubmissionType.Update,
        );
      }
    } //Add
    else {
      if (imageFile) {
        responseImageData = (await uploadFile('/files', imageFile, true)) as any;
        submitEngagementOrgs({ ...copyValues, imageId: responseImageData.data.id }, SubmissionType.Add);
      } else {
        submitEngagementOrgs({ ...copyValues }, SubmissionType.Add);
      }
    }
  };

  return (
    <Page isFetching={false} container={false}>
      <Formik
        initialValues={{
          name: engagementData ? engagementData.name : '',
          itemUrl: engagementData ? engagementData.itemUrl : '',
          location: engagementData?.location ? engagementData.location : [],
          engagementItems: items,
        }}
        validationSchema={EngagementSchema}
        onSubmit={initialValues => {
          handleSubmit(initialValues);
        }}
        enableReinitialize
      >
        {({ values, initialValues, submitForm, validateForm }) => (
          <FormikForm>
            <OrganizationHeader
              isFetching={isSubmiting}
              isForm
              headerText={`${origin} Early Engagement Organization`}
              onSubmit={() => submitForm()}
              submitButtonText="Save"
              isBackButtonVisible
              backModalTitleText="Go Back To Early Engagement Organization"
              onBackConfirm={handleBack}
              cancelModalTitleText={
                origin === 'Add'
                  ? 'Cancel adding a Early Engagement Organization'
                  : 'Cancel editing a Early Engagement Organization'
              }
              cancelModalBodyText={`You are going to cancel your 
                ${origin}. All of the information that you have filled will not be saved. Are you sure you want to cancel?`}
              onCancelConfirm={handleBack}
            />
            {submitEngagementErrors.length > 0 && (
              <StaticAlert className={classes.alertContainer} severity="error" icon={<ErrorIcon />}>
                <ul>
                  {submitEngagementErrors.map((e, i) => (
                    <li key={i}>{e}</li>
                  ))}
                </ul>
              </StaticAlert>
            )}

            <Container maxWidth="md" className={classes.container}>
              <Box className={classes.formSubHeader}>
                <Typography variant={'subtitle1'}>Logo</Typography>
              </Box>
              <AdminLogoUpload fileName={imageName} isEdit={loadImage} updateFile={setImageFile} />
            </Container>

            <Container maxWidth="md" className={classes.container}>
              <Box className={classes.formSubHeader}>
                <Typography variant={'subtitle1'}>Early Engagement Organization</Typography>
              </Box>
              <Box className={classes.formContainer}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Field
                      name={'name'}
                      label={'Name of Early Engagement Organization (Required)'}
                      placeholder={'Required'}
                      component={RenderTextField}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Field
                      name={'location'}
                      label={'Map Location (Select one or more)'}
                      placeholder={'Required'}
                      options={mapOptions}
                      component={RenderAutoCompleteFieldFixed}
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Field name={`itemUrl`} label={'Url (Optional)'} component={RenderTextField} />
                  </Grid>
                  <FieldArray name={'engagementItems'}>
                    {fieldArrayProps => {
                      const { push, remove, form } = fieldArrayProps;
                      const { values } = form;
                      const { engagementItems } = values;
                      return (
                        <>
                          {engagementItems.map((item, index) => (
                            <>
                              <Grid item xs={10} md={11}>
                                <Field
                                  name={`engagementItems[${index}].itemTitle`}
                                  label={'Contact Information (Required)'}
                                  placeholder={'Required'}
                                  component={RenderTextField}
                                />
                              </Grid>

                              <Grid item xs={2} md={1}>
                                <IconButton
                                  onClick={() => {
                                    if (engagementItems.length - 1 > 0) {
                                      const removed: any = remove(index);
                                      const aux: any = deletedItemsRef.current;
                                      aux.push(removed);
                                      deletedItemsRef.current = aux;
                                    }
                                  }}
                                >
                                  <Delete />
                                </IconButton>
                              </Grid>
                            </>
                          ))}

                          <Grid item>
                            <Button
                              className={classes.addItemBtn}
                              onClick={() => {
                                push({ itemTitle: '' });
                              }}
                              startIcon={<AddCircleOutline />}
                            >
                              Add Item
                            </Button>
                          </Grid>
                        </>
                      );
                    }}
                  </FieldArray>
                </Grid>
              </Box>
            </Container>
          </FormikForm>
        )}
      </Formik>
    </Page>
  );
};

export default OrganizationEngagementPage;
